module.exports = __webpack_public_path__ + "img/area_6N.acaa077b.png";